import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import toast from "react-hot-toast";
import UniversityService from "../../../services/KangarooServices/UniversityService";
import Select from "react-select";

const ChannelInsituteForm = ({
  isOpen,
  toggle,
  selectedItem,
  fetchData,
  activeTab,
  mediaGroup,
}) => {
  console.log("🚀 ~ ChannelInsituteForm ~ activeTab:", activeTab);
  const [filters, setFilters] = useState({
    destinationCountryId: "",
  });
  const [institutedata, setInstituteData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);
    return () => clearTimeout(timer);
  }, [filters]);
  const formik = useFormik({
    initialValues: {
      channelPartnerId: selectedItem?.id ?? null,
      orderIndex: selectedItem?.orderIndex,
      universityIds: Array.isArray(selectedItem?.universityIds)
        ? selectedItem.universityIds.map(String)
      : [],
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        // Build payload

        if (values?.id) {
          await ChannelService.update(values?.id, values);
          toast.success("Channel partners updated successfully");
        } else {
          await ChannelService.createAssignUni(values);
          toast.success("Channel partners created successfully");
        }

        // navigate(`/pages-list`);
        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const fetchUniversityData = async () => {
    setLoading(true);
    try {
      const response = await UniversityService.getList(
        debouncedFilters.destinationCountryId || "",
      );
      setInstituteData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  

// const CheckboxOption = (props) => (
//   <components.Option {...props}>
//     <input
//       type="checkbox"
//       checked={props.isSelected}
//       onChange={() => null}
//       style={{ marginRight: 8 }}
//     />
//     <label>{props.label}</label>
//   </components.Option>
// );



  const [data, setData] = useState([]);
  const fetchPartnerData = async () => {
    try {
      const response = await ChannelService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchPartnerData();
  }, []);
  useEffect(() => {
    fetchUniversityData();
  }, [debouncedFilters]);
  const instituteOptions = institutedata.map((i) => ({
    value: String(i.id),
    label: i.name,
  }));

  const partnerOptions = data?.map((type) => ({
    value: type.id,
    label: type.name,
  }));

  const mediaGroupOptions = mediaGroup.map((group) => ({
    label: group.name,
    value: group.id,
  }));
  const handleMediaGroupChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      destinationCountryId: selectedOption ? selectedOption.value : null,
    }));
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Assign institute</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {activeTab !== "Unassigned Partner" && (
            <div className="mb-2">
              <Label>Channel Partners</Label>
              <Select
                name="channelPartnerId"
                options={partnerOptions}
                value={
                  partnerOptions.find(
                    (opt) => opt.value === formik.values.channelPartnerId,
                  ) || null
                }
                onChange={(selected) =>
                  formik.setFieldValue(
                    "channelPartnerId",
                    selected ? selected.value : null,
                  )
                }
                placeholder="Select channel partner"
                isClearable
              />
            </div>
          )}
          <div className="mb-2">
            <Label>Order Index</Label>
            <Input
              type="number"
              name="orderIndex"
              value={formik.values.orderIndex}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.orderIndex && !!formik.errors.orderIndex}
            />
            <FormFeedback>{formik.errors.orderIndex}</FormFeedback>
          </div>
          <div className="mb-2">
            <Label>Destination Country</Label>

            <Select
              options={mediaGroupOptions}
              value={mediaGroupOptions.find(
                (option) => option.value === filters.id,
              )}
              onChange={handleMediaGroupChange}
              placeholder="Select destination country"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="mb-3">
            <Label>Affiliate Insitute</Label>
            <Select
              isMulti
              options={instituteOptions}
              value={instituteOptions.filter((opt) =>
                formik.values.universityIds.includes(opt.value),
              )}
              onChange={(selected) =>
                formik.setFieldValue(
                  "universityIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select affiliate institute"
            />
          </div>

          {/* <div className="mb-3">
  <Label>Affiliate Institute</Label>

  <Select
    isMulti
    closeMenuOnSelect={false}
    hideSelectedOptions={false}
    options={instituteOptions}
    components={{ Option: CheckboxOption }}
    value={instituteOptions.filter((opt) =>
      formik.values.universityIds.includes(opt.value)
    )}
    onChange={(selected) =>
      formik.setFieldValue(
        "universityIds",
        selected ? selected.map((s) => s.value) : []
      )
    }
    placeholder="Select affiliate institute"
  />
</div> */}


          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ChannelInsituteForm;
